<template>
  <div class="auth-overlay" @mousedown="onPressStart" @touchstart="onPressStart" @click.self="onOverlayClick">
    <div class="auth-dialog">
      <button class="auth-close" @click="closeDialog">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>

      <h1 class="auth-title">{{ titleText }}</h1>

      <!-- 登录（验证码/密码切换） -->
      <div v-if="mode === 'login'" class="auth-form">
        <div class="login-mode-tabs">
          <button :class="['login-mode-tab', { active: loginMode === 'captcha' }]" @click="loginMode = 'captcha'">验证码登录</button>
          <button :class="['login-mode-tab', { active: loginMode === 'pwd' }]" @click="loginMode = 'pwd'">密码登录</button>
        </div>

        <!-- 验证码登录 -->
        <template v-if="loginMode === 'captcha'">
          <div class="form-group">
            <input v-model="email" type="email" class="input-field" placeholder="请输入电子邮箱" @keyup.enter="handlePrimary" />
          </div>
          <div class="form-group captcha-row">
            <input v-model="captcha" type="text" class="input-field" placeholder="请输入验证码" maxlength="6" @keyup.enter="handlePrimary" />
            <button class="send-captcha-btn" :disabled="!canSendCaptcha || countdown > 0 || sendingCaptcha" @click="sendCaptcha">
              {{ sendingCaptcha ? '发送中...' : countdown > 0 ? countdown + 's' : '发送验证码' }}
            </button>
          </div>
        </template>

        <!-- 密码登录 -->
        <template v-if="loginMode === 'pwd'">
          <div class="form-group">
            <input v-model="userName" type="text" class="input-field" placeholder="请输入账户名" @keyup.enter="handlePrimary" />
          </div>
          <div class="form-group">
            <div class="password-wrapper">
              <input v-model="userPwd" :type="showUserPwd ? 'text' : 'password'" class="input-field" placeholder="请输入密码" @keyup.enter="handlePrimary" />
              <div class="password-toggle" @click="showUserPwd = !showUserPwd">
                <svg v-if="!showUserPwd" width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="1.5"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="1.5"/>
                </svg>
              </div>
            </div>
          </div>
        </template>

        <button class="btn btn-primary auth-btn" :disabled="!canSubmit" @click="handlePrimary">
          {{ loading ? loadingText : primaryText }}
        </button>
      </div>

      <!-- 注册 / 找回密码（邮箱+验证码） -->
      <div v-if="mode === 'register' || mode === 'forgot'" class="auth-form">
        <div class="form-group">
          <input v-model="email" type="email" class="input-field" placeholder="请输入电子邮箱" @keyup.enter="handlePrimary" />
        </div>
        <div class="form-group captcha-row">
          <input v-model="captcha" type="text" class="input-field" placeholder="请输入验证码" maxlength="6" @keyup.enter="handlePrimary" />
          <button class="send-captcha-btn" :disabled="!canSendCaptcha || countdown > 0 || sendingCaptcha" @click="sendCaptcha">
            {{ sendingCaptcha ? '发送中...' : countdown > 0 ? countdown + 's' : '发送验证码' }}
          </button>
        </div>
        <button class="btn btn-primary auth-btn" :disabled="!canSubmit" @click="handlePrimary">
          {{ loading ? loadingText : primaryText }}
        </button>
      </div>

      <!-- 设置密码 -->
      <div v-if="mode === 'reset'" class="auth-form">
        <div class="form-group">
          <div class="password-wrapper">
            <input
              v-model="newPassword"
              :type="showPassword ? 'text' : 'password'"
              class="input-field"
              placeholder="请输入新密码（至少6位）"
              @keyup.enter="handleReset"
            />
            <div class="password-toggle" @click="showPassword = !showPassword">
              <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="password-wrapper">
            <input
              v-model="confirmPassword"
              :type="showConfirmPassword ? 'text' : 'password'"
              class="input-field"
              placeholder="请再次输入新密码"
              @keyup.enter="handleReset"
            />
            <div class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
              <svg v-if="!showConfirmPassword" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary auth-btn"
          :disabled="!canReset"
          @click="handleReset"
        >
          {{ loading ? '设置中...' : '确定设置' }}
        </button>
      </div>

      <div class="auth-footer">
        <template v-if="mode === 'login'">
          <span class="auth-link" @click="switchMode('forgot')">找回密码</span>
          <span class="auth-divider">|</span>
          <span>没有账号，</span>
          <span class="auth-link" @click="switchMode('register')">去注册</span>
        </template>
        <template v-else-if="mode === 'register'">
          <span>已有账号，</span>
          <span class="auth-link" @click="switchMode('login')">去登录</span>
        </template>
        <template v-else-if="mode === 'forgot'">
          <span>想起密码，</span>
          <span class="auth-link" @click="switchMode('login')">去登录</span>
        </template>
        <template v-else>
          <span class="auth-link" @click="switchMode('login')">返回登录</span>
        </template>
      </div>

      <div v-if="toastMessage" :class="['toast', 'toast-' + toastType]">
        {{ toastMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { sendVerifyCode, emailLogin, pwdLogin, checkEmail, setPassword } from '../api'

export default {
  name: 'AuthDialog',
  data() {
    return {
      loginMode: 'captcha',
      email: '',
      userName: '',
      userPwd: '',
      newPassword: '',
      confirmPassword: '',
      captcha: '',
      showPassword: false,
      showConfirmPassword: false,
      showUserPwd: false,
      loading: false,
      sendingCaptcha: false,
      pressedOutside: false,
      countdown: 0,
      toastMessage: '',
      toastType: 'info'
    }
  },
  computed: {
    mode() {
      return this.$store.state.authMode
    },
    resetEmail() {
      return this.$store.state.resetEmail
    },
    titleText() {
      var map = { login: '登录账户', register: '注册账户', forgot: '找回密码', reset: '设置密码' }
      return map[this.mode] || '登录账户'
    },
    primaryText() {
      var map = { login: '登录', register: '立即注册', forgot: '验证' }
      return map[this.mode] || '登录'
    },
    loadingText() {
      var map = { login: '登录中...', register: '注册中...', forgot: '验证中...' }
      return map[this.mode] || '处理中...'
    },
    canSendCaptcha() {
      return /\S+@\S+\.\S+/.test(this.email) && !this.loading && !this.sendingCaptcha
    },
    canSubmit() {
      if (this.loading) return false
      if (this.mode === 'login' && this.loginMode === 'pwd') {
        return this.userName.length > 0 && this.userPwd.length >= 6
      }
      return this.email.length > 0 && this.captcha.length >= 4
    },
    canReset() {
      if (this.loading) return false
      return this.newPassword.length >= 6 && this.newPassword === this.confirmPassword
    }
  },
  watch: {
    mode(newMode) {
      if (newMode === 'reset') {
        this.email = this.resetEmail || ''
      }
      this.toastMessage = ''
    }
  },
  methods: {
    showToast(msg, type) {
      this.toastMessage = msg
      this.toastType = type || 'info'
      var self = this
      setTimeout(function() { self.toastMessage = '' }, 3000)
    },
    closeDialog() {
      this.$store.commit('SET_AUTH_DIALOG', false)
      this.resetForm()
    },
    onPressStart(e) {
      // 记录按下时是否在弹框外部（遮罩本身，而非对话框内容）
      this.pressedOutside = e.target === e.currentTarget
    },
    onOverlayClick() {
      // 只有“按下”和“松开”都发生在弹框外部，才算一次完整的外部点击才关闭
      if (this.pressedOutside) {
        this.closeDialog()
      }
      this.pressedOutside = false
    },
    applyAuthFromResponse(body) {
      // 用接口返回的 token 重新设置登录态
      // 返回结构：token/userId/userName 既可能在 data 内也可能在顶层，两者都兼容
      var newToken = (body.data && body.data.token) || body.token
      var userId = (body.data && body.data.userId) || body.userId
      var userName = (body.data && body.data.userName) || body.userName
      if (!newToken) return
      localStorage.setItem('sb-access-token', newToken)
      if (userId) {
        var savedUser = {
          id: userId,
          userName: userName || '',
          email: this.email || ''
        }
        localStorage.setItem('sb-user', JSON.stringify(savedUser))
        this.$store.commit('SET_USER', {
          id: userId,
          email: savedUser.email,
          user_metadata: { full_name: userName || savedUser.email.split('@')[0] }
        })
      }
      this.$store.dispatch('fetchCredits')
    },
    switchMode(mode) {
      this.$store.commit('SET_AUTH_MODE', mode)
      this.resetForm()
    },
    resetForm() {
      this.email = this.mode === 'reset' ? (this.resetEmail || '') : ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.captcha = ''
      this.showPassword = false
      this.showConfirmPassword = false
      this.toastMessage = ''
      this.loading = false
    },
    startCountdown() {
      this.countdown = 60
      var self = this
      var timer = setInterval(function() {
        self.countdown--
        if (self.countdown <= 0) clearInterval(timer)
      }, 1000)
    },
    async sendCaptcha() {
      if (!this.canSendCaptcha || this.countdown > 0) return
      this.sendingCaptcha = true
      try {
        var data = await sendVerifyCode(this.email)
        if (data.returnValue === 1 || data.success || data.code === 200) {
          this.startCountdown()
          this.showToast('验证码已发送', 'success')
        } else {
          this.showToast(data.message || '发送失败', 'error')
        }
      } catch (e) {
        this.showToast('发送失败，请重试', 'error')
      } finally {
        this.sendingCaptcha = false
      }
    },
    async handlePrimary() {
      if (this.mode === 'login') {
        if (this.loginMode === 'pwd') return this.pwdLogin()
        return this.emailLogin()
      }
      if (this.mode === 'register') {
        return this.emailLogin()
      }
      if (this.mode === 'forgot') {
        return this.handleForgot()
      }
    },
    async pwdLogin() {
      if (!this.canSubmit) return
      this.loading = true
      try {
        var body = await pwdLogin(this.userName, this.userPwd)
        var userData = body.data || body

        if (body.returnValue === 1 && userData.userId && userData.token) {
          localStorage.setItem('sb-access-token', userData.token)
          var savedUser = { id: userData.userId, userName: userData.userName || this.userName, email: '' }
          localStorage.setItem('sb-user', JSON.stringify(savedUser))
          this.$store.commit('SET_USER', {
            id: userData.userId,
            email: '',
            user_metadata: { full_name: userData.userName || this.userName }
          })
          this.$store.dispatch('fetchCredits')

          if (String(userData.infoState) !== '1') {
            this.showToast('请先设置密码', 'info')
            this.$store.commit('SET_AUTH_DIALOG', { show: true, mode: 'reset', email: '' })
          } else {
            this.closeDialog()
          }
        } else {
          this.showToast(body.message || body.error || '登录失败', 'error')
        }
      } catch (e) {
        this.showToast('登录失败，请重试', 'error')
      } finally {
        this.loading = false
      }
    },
    async emailLogin() {
      if (!this.canSubmit) return
      this.loading = true
      try {
        var body = await emailLogin(this.email, this.captcha)
        var userData = body.data || body

        if (body.returnValue === 1 && userData.userId && userData.token) {
          localStorage.setItem('sb-access-token', userData.token)
          // 保存用户信息到 localStorage，刷新时可恢复
          var savedUser = {
            id: userData.userId,
            userName: userData.userName,
            email: this.email
          }
          localStorage.setItem('sb-user', JSON.stringify(savedUser))
          this.$store.commit('SET_USER', {
            id: userData.userId,
            email: this.email,
            user_metadata: { full_name: userData.userName || this.email.split('@')[0] }
          })
          this.$store.dispatch('fetchCredits')

          if (String(userData.infoState) !== '1') {
            this.showToast('请先设置密码', 'info')
            this.$store.commit('SET_AUTH_DIALOG', { show: true, mode: 'reset', email: this.email })
          } else {
            this.closeDialog()
          }
        } else {
          this.showToast(body.message || body.error || '登录失败', 'error')
        }
      } catch (e) {
        this.showToast('登录失败，请重试', 'error')
      } finally {
        this.loading = false
      }
    },
    async handleForgot() {
      if (!this.canSubmit) return
      this.loading = true
      try {
        var body = await checkEmail(this.email, this.captcha)
        if (body.returnValue === 1 || body.success) {
          // 验证成功后用返回的 token 重新设置登录态
          this.applyAuthFromResponse(body)
          this.$store.commit('SET_AUTH_DIALOG', { show: true, mode: 'reset', email: this.email })
          this.showToast('验证成功，请设置新密码', 'success')
        } else {
          this.showToast(body.message || '验证失败', 'error')
        }
      } catch (e) {
        this.showToast('验证失败，请重试', 'error')
      } finally {
        this.loading = false
      }
    },
    handleReset() {
      if (!this.canReset) return
      this.loading = true
      var self = this
      setPassword(self.newPassword, self.confirmPassword).then(function(body) {
        self.loading = false
        if (body.returnValue === 1 || body.success) {
          // 设置密码成功后，用接口返回的 token 重新设置登录态
          self.applyAuthFromResponse(body)
          self.showToast('密码设置成功', 'success')
          self.closeDialog()
        } else {
          self.showToast(body.message || '密码设置失败', 'error')
        }
      }).catch(function() {
        self.loading = false
        self.showToast('密码设置失败，请重试', 'error')
      })
    }
  }
}
</script>

<style scoped>
.auth-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.auth-dialog {
  background: var(--bg-card);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  padding: 48px 40px 32px;
  width: 100%;
  max-width: 440px;
  position: relative;
  animation: scaleIn 0.25s ease;
}

.auth-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  cursor: pointer;
  transition: var(--transition);
}

.auth-close:hover {
  color: var(--text-primary);
  background: var(--bg-hover);
}

.auth-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 28px;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.form-group {
  position: relative;
}

.captcha-row .input-field {
  padding-right: 110px;
}

.send-captcha-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: var(--accent);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  transition: var(--transition);
}

.send-captcha-btn:disabled {
  color: var(--text-muted);
  cursor: not-allowed;
}

.send-captcha-btn:hover:not(:disabled) {
  color: var(--accent-hover);
}

.password-wrapper {
  position: relative;
}

.password-wrapper .input-field {
  padding-right: 44px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: var(--text-muted);
  display: flex;
  align-items: center;
}

.password-toggle:hover {
  color: var(--text-secondary);
}

.auth-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 6px;
}

.auth-footer {
  text-align: center;
  font-size: 14px;
  color: var(--text-secondary);
  margin-top: 8px;
}

.auth-link {
  color: var(--accent);
  cursor: pointer;
  font-weight: 500;
  transition: var(--transition);
}

.auth-link:hover {
  color: var(--accent-hover);
}

.auth-divider {
  margin: 0 8px;
  color: var(--text-muted);
}

.login-mode-tabs {
  display: flex;
  gap: 0;
  background: var(--bg-input);
  border-radius: var(--radius-sm);
  padding: 3px;
  margin-bottom: 4px;
}

.login-mode-tab {
  flex: 1;
  padding: 6px 0;
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  transition: var(--transition);
}

.login-mode-tab.active {
  background: var(--accent);
  color: #fff;
}

.login-mode-tab:hover:not(.active) {
  color: var(--text-primary);
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
</style>
